import { render } from "./PaletteBar.vue?vue&type=template&id=65b808d2"
import script from "./PaletteBar.vue?vue&type=script&lang=js"
export * from "./PaletteBar.vue?vue&type=script&lang=js"

import "./PaletteBar.vue?vue&type=style&index=0&id=65b808d2&lang=scss"

import exportComponent from "/Users/william/Documents/beadographer3/bead3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__